import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

const mutateDeleteNewsletter = async ({
  id,
  news_number,
}: {
  id: string;
  news_number: number;
}) => {
  return await axiosAuth.delete(
    `${GET_COMMUNITIES}/${id}/newsletter/${news_number}`
  );
};

const useDeleteNewsletterMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      news_number: number;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteNewsletter,
    ...queryParams,
  });

export default useDeleteNewsletterMutation;
